import { NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { SimpleIconsDiggComponent } from './simple-icons-digg.component';
 @NgModule({
    imports:      [ BrowserModule ],
    providers:    [],
    declarations: [ SimpleIconsDiggComponent ],
    exports:      [ SimpleIconsDiggComponent ],
    bootstrap:    []
})
export class SimpleIconsDiggModule {}
